import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './styles/CreateTeacherPage.css'; 
import { useNavigate, useParams } from 'react-router-dom'; 

function StockCreatePage({ isSidebarCollapsed }) {
  const [errors, setErrors] = useState({}); 
  const navigate = useNavigate();
  const { branchId } = useParams();

  const [formData, setFormData] = useState({
    branch_name: '',
    branch_code: '',
    address: ''
  });


  useEffect(() => {
   
    if (branchId) {
      api.get(`/utils/branch/detail/${branchId}`)
        .then(response => {
          const data = response.data.data[0]; // Sesuaikan dengan struktur respons API Anda
          setFormData({
            branch_name: data.branch_name,
            branch_code: data.branch_code,
            address: data.address
          });
        })
        .catch(error => console.error('Error fetching branch detail:', error));
    }
  }, [branchId]);

  const validateForm = (formData) => {
    const errors = {};
    if (!formData.branch_name) errors.branch_name = 'Branch Name is required';
    if (!formData.address) errors.address = 'Address is required';
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.log('Validation Errors:', validationErrors);
    } else {
      const confirmation = window.confirm('Are you sure you want to proceed with this action?');
      if (!confirmation) {
        return;
      }

      const requestBody = {
        data: {
          branchData: formData,
        }
      };

      const apiCall = branchId ? 
        api.put(`/utils/branch/update/${branchId}`, requestBody) : 
        api.post('/utils/branch/save', requestBody);


      apiCall
        .then(response => {
          const successMessage = response.data.message;
          console.log(successMessage);
          navigate('/success', { state: { message: successMessage } });
        })
        .catch(error => {
          console.error('Error adding/updating branch:', error);
          navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    }
  };

  return (
    <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
      <div className="page-title">{branchId ? 'Edit Branch' : 'Create New Branch'}</div>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="section">
            <h3 className="section-header">Branch Data</h3>
            <label>Branch Name</label>
            <input 
              type="text" 
              name="branch_name" 
              value={formData.branch_name} 
              onChange={e => setFormData({ ...formData, branch_name: e.target.value })} 
              disabled={!!branchId} // Disable jika dalam mode edit
            />
            {errors.branch_name && <div className="error-message">{errors.branch_name}</div>}
            {branchId &&(
              <>
              <label>Branch Code</label>
              <input 
                type="text" 
                name="branch_code" 
                value={formData.branch_code} 
                onChange={e => setFormData({ ...formData, branch_code: e.target.value })} 
                disabled={!!branchId}
              />
              </>
            )}

            <label>Address</label>
            <textarea 
              name="address" 
              value={formData.address} 
              onChange={e => setFormData({ ...formData, address: e.target.value })}
            ></textarea>
          </div>

          <div className="search-container">
            <table>
              <tr>
                <td>
                  <button className="profile-button" type="submit">{branchId ? 'Update' : 'Submit'}</button>  
                </td>
              </tr>
              <tr>
                <td>
                  <button className="profile-button" onClick={() => navigate('/')}>Back</button>
                </td>
              </tr>
            </table>
          </div>
        </form>
      </div>
    </div>
  );
}

export default StockCreatePage;
